import { get, post, put, destroy, upload, uploadPut } from 'utils/fetchRequest';

export const getPageContent = async (pageId) => {
    try {
        const result = await get(`pages/${pageId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

/**
 * Хуудсуудыг авах
 * @param {boolean|null} isHeader - true: header, false: footer, null: бүгд
 * @param {string} query - нэмэлт query string (жишээ: '&parentId=5')
 */
export const getPageList = async (isHeader, query = '') => {
    try {
        const headerParam =
            isHeader === true ? '&isHeader=1' : isHeader === false ? '&isHeader=0' : '';
        const result = await get(`pages?1=1${headerParam}${query}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getPageAllList = async () => {
    try {
        const result = await get('pages/all');
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createPage = async (data) => {
    try {
        const result =
            data instanceof FormData ? await upload('pages', data) : await post('pages', data);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updatePage = async (id, data) => {
    try {
        const result =
            data instanceof FormData
                ? await uploadPut(`pages/${id}`, data)
                : await put(`pages/${id}`, data);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deletePage = async (id) => {
    try {
        const result = await destroy(`pages/${id}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const reorderPages = async (items) => {
    try {
        const result = await put('pages/reorder', { items });
        return result;
    } catch (err) {
        return { error: err };
    }
};
